module.exports = __webpack_public_path__ + "img/manufacture@2x.7bd7557.jpg";